const whiteSiteLogo = '/wp-content/uploads/2025/07/Group-11.svg';
const primarySiteLogo = '/wp-content/uploads/2025/07/Group-11.svg';
const primaryColor = '#31E8EB';
const secondaryColor = '#295E61';

/**
 * Change Navbar Brand to Black Logo
 */
function changeNavbarBrandToPrimary() {
	const navbarBrand = jQuery( '.navbar-brand img' )[0];
	if ( navbarBrand && navbarBrand.src !== primarySiteLogo ) {
		navbarBrand.src = primarySiteLogo;
	}
}

/**
 * Change Navbar Brand to White Logo
 */
function changeNavbarBrandToWhite() {
	const navbarBrand = jQuery( '.navbar-brand img' )[0];
	if ( navbarBrand && navbarBrand.src !== whiteSiteLogo ) {
		navbarBrand.src = whiteSiteLogo;
	}
}

/**
 * Change Nav Link Color
 *
 * @param {string} color - Hex code of color to change nav links to
 */
function changeNavLinkColor( color ) {
	const navLinks = document.querySelectorAll( '.navbar-nav a' );
	navLinks.forEach( ( link ) => {
		link.style.color = color;
	} );
}

export default function initNavbarScroll() {
	const isMobile = jQuery( window ).width() <= 960;
	if ( isMobile ) {
		changeNavbarBrandToPrimary();
	}

	// Nav Scroll
	const navems =
		Number(
			getComputedStyle( document.body, '' ).fontSize.match( /(\d*(\.\d*)?)px/ )[1]
		) * 2;
	const logoems =
		Number(
			getComputedStyle( document.body, '' ).fontSize.match( /(\d*(\.\d*)?)px/ )[1]
		) * 5;

	jQuery( window ).scroll( function() {
		let percentage;
		// Starts at requiredOffset and goes down to 0
		// const marginTop = requiredOffset * (1 - percentage);

		// Starts at requiredOffset and goes down to 0
		percentage = Math.min( 1, jQuery( window ).scrollTop() / logoems );

		// Opacity of frame
		const alpha = percentage;

		// const blendOpacity = $(window).scrollTop() / 550;
		const navbar = jQuery( '.navbar' );

		const scrollTop = jQuery( window ).scrollTop();

		if ( scrollTop <= navems && ! isMobile ) {

			navbar.removeClass( 'fixed-nav' );
			navbar.removeClass( 'scrolled' );
			console.log('Removing scrolled class - at top');
		} else {
			navbar.addClass( 'fixed-nav' );
			if ( ! isMobile ) {
				navbar.addClass( 'scrolled' );
				console.log('Adding scrolled class - scrolling');
			}
		}
	} );
}
